import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { PageId } from "@@/shared/pages/page-id";
import { z } from "zod";

const homeSettingGlobalId = "home_setting";

type HomeSettingGlobal = {
    _id: typeof homeSettingGlobalId;
    _type: "GLOBAL_HOME_SETTING";
    _updatedAt: IsoAndUnixTimestamp;
    pageId: PageId | null;
};

const homeSettingGlobalZodObject = z.object({
    _id: z.literal(homeSettingGlobalId),
    _type: z.literal("GLOBAL_HOME_SETTING"),
    _updatedAt: z.string(),
    pageId: z.string().nullable(),
});

export { homeSettingGlobalId, homeSettingGlobalZodObject };
export type { HomeSettingGlobal };
